<nz-card class="flow-card" nzTitle="Starlink Order">
    <p class="flow-card__subtitle">Place your Starlink order, then enter the order number below.</p>

    <nz-spin [nzSpinning]="loading">
        <div class="order-link-row" *ngIf="starlinkUrl">
            <button nz-button nzType="primary" nzSize="large" (click)="openStarlink()">
                <span nz-icon nzType="link"></span>
                Open Starlink Order Page
            </button>
        </div>

        <form nz-form [formGroup]="orderForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
            <nz-form-item class="flow-form__item">
                <nz-form-label [nzRequired]="true" nzFor="starlinkOrderNumber">Starlink Order Number</nz-form-label>
                <nz-form-control>
                    <input nz-input id="starlinkOrderNumber" formControlName="starlinkOrderNumber"
                        placeholder="Enter order number" />
                </nz-form-control>
            </nz-form-item>

            <div class="flow-actions flow-actions--trailing">
                <button nz-button nzType="primary" [disabled]="orderForm.invalid" (click)="submit()">
                    Continue
                </button>
            </div>
        </form>
    </nz-spin>
</nz-card>